import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.afterservice.replacing.machinepart');
import { OnInit, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-afterservice-replacing-machinepart',
template: templateSource || '',
    styles: [``],
})
export class PortalAfterserviceReplacingMachinepartComponent implements OnInit {

    @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;

    public list: any[] = [];
    public page: number = 1;
    public lastPage: number = 1;
    public loading: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadReplaceAlert();
    }

    public async loadReplaceAlert() {
        if (this.loading) return;

        this.loading = true;

        const { code, data } = await wiz.call('status', {
            page: this.page,
            dump: 20
        });

        this.loading = false;

        if (code !== 200 || !data) {
            this.list = [];
            return;
        }

        this.lastPage = data.last_page || 1;
        this.list = data.rows || [];
        await this.service.render();
    }

    public async loadMore() {
        if (this.loading || this.page >= this.lastPage) return;

        this.loading = true;
        this.page++;

        const { code, data } = await wiz.call('status', {
            page: this.page,
            dump: 20
        });

        this.loading = false;

        if (code !== 200 || !data) return;

        this.lastPage = data.last_page || 1;
        this.list = [...this.list, ...(data.rows || [])];
        await this.service.render();
    }

    public onScroll(event: Event) {
        const el = event.target as HTMLElement;
        const threshold = 100;

        if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
            this.loadMore();
        }
    }
}

export default PortalAfterserviceReplacingMachinepartComponent;